export const SEARCH_SORT_OPTIONS = [
  { value: "recommended", label: "Recommended", mobileLabel: "Recommended" },
  { value: "best-selling", label: "Best Selling", mobileLabel: "Best Selling" },
  { value: "fresh-drops", label: "Fresh Drops", mobileLabel: "Fresh Drops" },
  { value: "price-asc", label: "Price: Low to High", mobileLabel: "Price ↑" },
  { value: "price-desc", label: "Price: High to Low", mobileLabel: "Price ↓" },
  { value: "thc-desc", label: "THC: High to Low", mobileLabel: "THC ↓" },
  { value: "cbd-desc", label: "CBD: High to Low", mobileLabel: "CBD ↓" },
] as const;

export type SearchSortValue = (typeof SEARCH_SORT_OPTIONS)[number]["value"];
